<template>
  <div class="pp" @click="print">
    <img class="pimg" src="@/assets/img/print.png" alt="" />打印
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    print() {
      this.$http
        .post("admin/employeeApproval/print", { id: this.dataInfo.id })
        .then((res) => {
          if (res.code == 1) {
            window.open(res.data.pdf_link);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.pp {
  font-size: 12px;
  color: #646b75;
  margin: 0 30px 0 0;
  cursor: pointer;
  font-weight: 500;
}
.pimg {
  width: 12px;
  height: 12px;
  margin: 0 5px 0 0;
}
</style>

